import { render, staticRenderFns } from "./AbsensiJasmani.vue?vue&type=template&id=1259c102"
import script from "./AbsensiJasmani.vue?vue&type=script&lang=js"
export * from "./AbsensiJasmani.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports